import {PlatformDataType} from 'src/interfaces/Platform.interface'

export type UniquePlatformChannel = {
  key: string
  label: string
  isConnected: boolean
}

const getPlatformKey = (platform: PlatformDataType): string => {
  const info = platform.platform_info
  return String(info?.id ?? info?.name ?? platform.type ?? platform.code ?? platform.name)
}

const getPlatformLabel = (platform: PlatformDataType): string =>
  platform.platform_info?.display_name ||
  platform.platform_info?.name ||
  platform.display_name ||
  platform.name

export const getUniquePlatformChannels = (
  platforms: PlatformDataType[] = [],
  limit?: number
): UniquePlatformChannel[] => {
  const unique = new Map<string, UniquePlatformChannel>()

  for (const platform of platforms) {
    const key = getPlatformKey(platform)
    const existing = unique.get(key)

    if (existing) {
      if (platform.isConnected) {
        existing.isConnected = true
      }
      continue
    }

    unique.set(key, {
      key,
      label: getPlatformLabel(platform),
      isConnected: Boolean(platform.isConnected),
    })
  }

  const channels = Array.from(unique.values())
  return typeof limit === 'number' ? channels.slice(0, limit) : channels
}

/** All connected integrations, one pill per catalog platform (matches /listing-channels scope). */
export const getHeroDisplayChannels = (
  connectedPlatforms: PlatformDataType[] = []
): UniquePlatformChannel[] => getUniquePlatformChannels(connectedPlatforms).filter(c => c.label !== 'Commercium OMS')
